'use client';

import { usePathname, useRouter } from 'next/navigation';

import TabFilterItem from '@/app/(football)/[team]/_components/common/TabFilterItem';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';

export default function Tab() {
  const router = useRouter();
  const pathname = usePathname();
  const { teamSlug } = useTeamConfig();

  const tabs = [
    { label: '사용하기', path: `/${teamSlug}/point-lounge/use` },
    { label: '모으기', path: `/${teamSlug}/point-lounge/earn` },
  ];

  return (
    <div className="mt-5 flex w-full">
      {tabs.map((tab) => (
        <div key={tab.path} className="flex flex-1 justify-center">
          <TabFilterItem
            label={tab.label}
            isSelected={pathname === tab.path}
            underline
            onClick={() => router.push(tab.path, { scroll: false })}
            className="w-full"
          />
        </div>
      ))}
    </div>
  );
}
